var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 39,
    viewBox: "0 0 16 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.29289 38.7071C7.68341 39.0976 8.31658 39.0976 8.7071 38.7071L15.0711 32.3431C15.4616 31.9526 15.4616 31.3195 15.0711 30.9289C14.6805 30.5384 14.0474 30.5384 13.6568 30.9289L7.99999 36.5858L2.34314 30.9289C1.95262 30.5384 1.31945 30.5384 0.928926 30.9289C0.538402 31.3195 0.538402 31.9526 0.928926 32.3431L7.29289 38.7071ZM7 -1.88649e-07L6.99999 38L8.99999 38L9 1.88649e-07L7 -1.88649e-07Z",
    fill: "#8F91AA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.6c17ab653d38bc08e4e7334601e67ea7.svg";
export { ForwardRef as ReactComponent };